import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './TaskDescription.module.css';
import { Icon } from '../../../../shared/ui';

interface TaskDescriptionProps {
    description: string;
    classes?: string;
}

export const TaskDescription = memo(({ description, classes }: TaskDescriptionProps) => {
    if (!description || description.trim().length === 0) {
        return null;
    }
    return (
        <div className={classNames(cls.TaskDescriptionContainer, [classes])} title={description}>
            <span className={cls.iconSpan}>
                <Icon iconName={'taskDescription'} />
            </span>{' '}
            <span className={cls.description}>{description}</span>
        </div>
    );
});
